import React from 'react';
import { GenericDeleteModal } from 'components';
import { VoidFn } from 'types/baseTypes';

interface DeleteJobConfirmationModalProps {
  onCloseClick: VoidFn;
  handleDelete: VoidFn;
  processingDelete: boolean;
}

export const DeleteJobConfirmationModal: React.FC<DeleteJobConfirmationModalProps> = ({
  onCloseClick,
  handleDelete,
  processingDelete
}) => {
  return (
    <GenericDeleteModal
      onPrimaryBtnClick={handleDelete}
      onSecondaryBtnClick={onCloseClick}
      isActionInProgress={processingDelete}
      primaryBtnId="delete-job-confirm"
      primaryBtnLabel="Yes, delete"
      primaryBtnStyle="path-stroke-current"
      secondaryBtnId="delete-job-cancel"
      secondaryBtnLabel="No, cancel"
      showModal={true}
      title="Confirm deletion"
      subTitle="Are you sure you want to delete this job?"
    />
  );
};
